import { createColumnHelper } from '@tanstack/react-table';
import { TableCell } from './TableCell';
import { VariantActionsCell } from './VariantActionsCell';

const columnHelper = createColumnHelper();

const labelDisplay = {
  hot: "Hot",
  bestseller: "Bestseller",
  new: "New",
  premium: "Premium",
  high_strength: "High Strength",
  exotic: "Exotic",
  bundles: "Bundles",
  biggest_saving: "Biggest Saving",
  world_tour : "World Tour",
  spot_light : "Spot Light",
  none: "None",
};

export const columns = [
  columnHelper.accessor('variantCode', {
    header: 'Bar Code',
    cell: TableCell,
  }),
  columnHelper.accessor('variantImage', {
    header: 'Variant Image',
    cell: TableCell,
  }),
  columnHelper.accessor('variantName', {
    header: 'Name',
    cell: TableCell,
  }),
  // columnHelper.accessor('description', {
  //   header: 'Description',
  //   cell: TableCell,
  // }),
  columnHelper.accessor('vol', {
    header: 'Volume',
    cell: TableCell,
  }),
  columnHelper.accessor('alcohol_percentage', {
    header: 'Alcohol Perc.',
    cell: TableCell,
  }),
  columnHelper.accessor('purchasePrice', {
    header: 'Purchase Price',
    cell: TableCell,
  }),
  columnHelper.accessor('quantity', {
    header: 'Quantity',
    cell: TableCell,
  }),
  // columnHelper.accessor('storePricing', {
  //   header: 'Store Prices',
  //   cell: ({ getValue }) => {
  //     const prices = getValue() || [];
  //     if (prices.length === 0) return <span className="text-gray-400">Not set</span>;
  //     return <span>{prices.length} store{prices.length > 1 ? "s" : ""}</span>;
  //   },
  // }),
  columnHelper.accessor('label', {
    header: 'Label',
    cell: ({ getValue }) => <span>{labelDisplay[getValue()] || "None"}</span>,
  }),
  // columnHelper.accessor('isTopSellingProduct', {
  //   header: 'Top Selling Product',
  //   cell: TableCell,
  // }),
  columnHelper.accessor('status', {
    header: 'Active',
    cell: TableCell,
  }),
  columnHelper.display({
    header: 'Action',
    id: 'actions',
    cell: VariantActionsCell,
  }),
];




// import { createColumnHelper } from '@tanstack/react-table';
// import { TableCell } from './TableCell';
// import { EditCell } from './EditCell';
// import { EditPrices } from './EditPrices';

// const columnHelper = createColumnHelper();

// export const columns = [
//   columnHelper.accessor('variantCode', {
//     header: 'Bar Code',
//     cell: TableCell,
//     meta: {
//       type: 'text',
//       required: true,
//     },
//   }),
//   columnHelper.accessor('variantImage', {
//     header: 'Variant Image',
//     cell: TableCell,
//     meta: {
//       type: 'file',
//       required: true
//     },
//   }),
//   columnHelper.accessor('variantName', {
//     header: 'Name',
//     cell: TableCell,
//     meta: {
//       type: 'text',
//       required: true,
//     },
//   }),
//   columnHelper.accessor('description', {
//     header: 'Description',
//     cell: TableCell,
//     meta: {
//       type: 'textarea',
//       required: true,
//     },
//   }),
//   columnHelper.accessor('vol', {
//     header: 'Volume',
//     cell: TableCell,
//     meta: {
//       type: 'text',
//       required: false,
//     },
//   }),
//   columnHelper.accessor('alcohol_percentage', {
//     header: 'Alcohol Perc.',
//     cell: TableCell,
//     meta: {
//       type: 'number',
//       required: false,
//     },
//   }),
//   columnHelper.accessor('purchasePrice', {
//     header: 'Purchase Price',
//     cell: TableCell,
//     meta: {
//       type: 'number',
//       required: true,
//     },
//   }),
//   columnHelper.accessor('quantity', {
//     header: 'Quantity',
//     cell: TableCell,
//     meta: {
//       type: 'number',
//       required: true,
//     },
//   }),
//   columnHelper.display({
//     header: 'Store Prices',
//     id: 'edit',
//     cell: EditPrices,
//   }),
//   columnHelper.accessor('label', {
//     header: 'Label',
//     cell: ({ getValue, row, table }) => {
//       const value = getValue();

//       const handleChange = (e) => {
//         table.options.meta.updateData(row.index, "label", e.target.value);
//       };

//       return (
//         <select value={value || "none"} onChange={handleChange}>
//           <option value="hot">Hot</option>
//           <option value="bestseller">Bestseller</option>
//           <option value="new">New</option>     
//           <option value="premium">Premium</option>
//           <option value="high_strength">High Strength</option>
//           <option value="exotic">Exotic</option>
//           <option value="bundles">Bundles</option>
//           <option value="biggest_saving">Biggest Saving</option>
//           <option value="none">None</option>
//         </select>
//       );
//     },
//     meta: {
//       type: "select",
//       options: [
//         { value: "hot", label: "Hot" },
//         { value: "bestseller", label: "Bestseller" },
//         { value: "new", label: "New" },   
//         { value: "premium", label: "Premium" },
//         { value: "high_strength", label: "High Strength" },
//         { value: "exotic", label: "Exotic" },
//         { value: "bundles", label: "Bundles" },
//         { value: "biggest_saving", label: "Biggest Saving" },
//         { value: "none", label: "None" },
//       ],
//       required: false,
//     },
//   }),
//   columnHelper.accessor('isTopSellingProduct', {
//     header: 'Top Selling Product',
//     cell: TableCell,
//     meta: {
//       type: 'checkbox',
//       required: false,
//     },
//   }),
//   columnHelper.accessor('status', {
//     header: 'Active',
//     cell: TableCell,
//     meta: {
//       type: 'checkbox',
//       required: false,
//     },
//   }),


//   columnHelper.display({
//     header: 'Action',
//     id: 'edit',
//     cell: EditCell,
//   }),
// ];
